import { render, staticRenderFns } from "./UiFilterChip.vue?vue&type=template&id=207621c6&"
import script from "./UiFilterChip.vue?vue&type=script&lang=js&"
export * from "./UiFilterChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports